import React from 'react';
import classNames from 'classnames';

import css from './IconPlus.module.css';

/**
 * Chevron icon used as the filter section expand / collapse toggle.
 * Points upward when `isOpen` is true, downward when false.
 *
 * @component
 * @param {Object}  props
 * @param {string}  [props.className]
 * @param {string}  [props.rootClassName]
 * @param {boolean} [props.isOpen]   true = section open → chevron points up
 */
const IconPlus = props => {
  const { className, rootClassName, isOpen = true } = props;
  const classes = classNames(rootClassName || css.root, className, {
    [css.isOpen]: isOpen,
  });

  return (
    <svg
      className={classes}
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="none"
      aria-hidden="true"
    >
      <path
        d="M1 1L5 5L9 1"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconPlus;
